import { create } from 'zustand';
import { Recurso, StatusRecurso } from '../model/Candidato/Recurso';
import RecursoViewModel from '../viewmodel/RecursoViewModel';

interface RecursoStore {
  recursos: Recurso[];
  setRecursos: (recursos: Recurso[]) => void;
  atualizarStatusRecurso: (recursoId: string, status: string) => Promise<void>;
  obterRecursoPorId: (recursoId: string) => Promise<Recurso | undefined>;
  criarRecurso: (texto: string, candidatoBancaId: string, cpf: string, passaporte: string, token: string) => Promise<void>;
  getRecursos: (bancaId: string, status?: StatusRecurso) => Promise<void>;
  getRecursosPendentes: () => Promise<void>;
}

const useRecursoStore = create<RecursoStore>((set) => ({
  recursos: [],
  setRecursos: (recursos: Recurso[]) => set({ recursos }),

  atualizarStatusRecurso: async (recursoId: string, status: string) => {
    try {
        const recurso = await RecursoViewModel.atualizarStatusRecurso(recursoId, status.toUpperCase());
        set((state) => ({
            recursos: state.recursos.map(r => r.id === recursoId ? recurso : r),
        }));        
    } catch (error) {
        console.error('Erro ao atualizar status do recurso:', error);
        throw error; 
    }
},

  obterRecursoPorId: async (recursoId: string) => {
    try {
      const recurso = await RecursoViewModel.obterRecursoPorId(recursoId);
      return recurso;
    } catch (error) {
      console.error('Erro ao obter recurso:', error);
      return undefined;
    }
  },

  criarRecurso: async (texto: string, candidatoBancaId: string, cpf: string, passaporte: string, token: string) => {
    try {
      const recurso = await RecursoViewModel.criarRecurso(texto, candidatoBancaId, cpf, passaporte, token);
      set((state) => ({
        recursos: [...state.recursos, recurso],
      }));
    } catch (error) {
      console.error('Erro ao criar recurso:', error);
    }
  },

  getRecursos: async (bancaId: string, status?: StatusRecurso) => {
    try {
      const recursos = await RecursoViewModel.getRecursosCompleto(bancaId, status);
      set({ recursos });
    } catch (error) {
      console.error('Erro ao obter recursos:', error);
    }
  },

  getRecursosPendentes: async () => {
    try {
      const response = await RecursoViewModel.obterRecursosPendentes();
      set({ recursos: response });
    } catch (error) {
      console.error('Erro ao obter recursos pendentes:', error);
    }
  },
}));

export default useRecursoStore;